import styled from 'styled-components'

import { Skeleton } from '@root/shared/ui-kit'

export const PnlCalendarLoading: React.FC = () => (
  <Root>
    {Array.from({ length: 40 }, (_, index) => (
      <DayCell
        key={index}
        $opacity={[0, 1, 2, 3, 4, 36, 37, 38, 39].includes(index) ? 0 : 1}
        height="100%"
        width="100%"
      />
    ))}
  </Root>
)

const Root = styled.div`
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  grid-template-rows: repeat(5, minmax(0, 1fr));
  height: 100%;
  min-height: 0;
  gap: 6px;
`

const DayCell = styled(Skeleton)<{ $opacity: number }>`
  opacity: ${(props) => props.$opacity};
  background: var(--backgroundA-2);

  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 2px;
  border-radius: 6px;
  min-width: 0;
  border-radius: 4px;

  border-radius: 4px;
  background: color-mix(in srgb, var(--backgroundA-3) 80%, transparent);
`
